const LEGACY_INSTRUMENT_BELL_PATH = /^\/instruments\/([^/?#]+)\/?$/
const INSTRUMENT_ID_ONLY_PATH = /^\/instrument\/([^/?#]+)\/?$/

/**
 * Normalizes bell `relatedUrl` values for in-app navigation.
 * Legacy survey bells used `/instruments/{id}` (magic-link onboarding); logged-in SP users
 * need `/instrument/{id}/info`. Bare `/instrument/{id}` is also normalized.
 */
export function resolveNotificationNavigatePath(url: string): string {
  const trimmed = url.trim()
  const legacyPlural = LEGACY_INSTRUMENT_BELL_PATH.exec(trimmed)
  if (legacyPlural?.[1]) {
    return `/instrument/${legacyPlural[1]}/info`
  }
  const instrumentOnly = INSTRUMENT_ID_ONLY_PATH.exec(trimmed)
  if (instrumentOnly?.[1] && !trimmed.endsWith('/info')) {
    return `/instrument/${instrumentOnly[1]}/info`
  }
  // BFP-1025 — signup-survey eKYC bells deep-link to /ekyc; web has no /ekyc route.
  if (trimmed === '/ekyc' || trimmed.startsWith('/ekyc?')) {
    return trimmed.replace(/^\/ekyc/, '/rewards')
  }
  return trimmed
}

